'use client';

import { useEffect, useRef } from 'react';

export default function useTabActive(onFocus?: () => void) {
  const callbackRef = useRef(onFocus);

  useEffect(() => {
    callbackRef.current = onFocus;
  });

  useEffect(() => {
    const activate = () => callbackRef.current?.();

    const handleVisibility = () => {
      if (document.visibilityState === 'visible') activate();
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', activate);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', activate);
    };
  }, []);
}
